module.exports = __webpack_public_path__ + "static/media/organisation-d-un-atelier-de-dialogue-public-pour-le-projet-SIENNA.a3116227.jpg";